// ==============================|| OVERRIDES - TABLE CELL (ERPNext / Brevo style list view) ||============================== //

export default function TableCell(theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        root: ({ ownerState }) => {
          const base = {
            fontSize: '0.8125rem',
            lineHeight: 1.45,
            padding: '12px 16px',
            borderBottom: `1px solid ${theme.vars.palette.grey[100]}`,
            color: theme.vars.palette.grey[800]
          };
          if (ownerState.align === 'right') return { ...base, textAlign: 'right', '& .MuiOutlinedInput-input': { textAlign: 'right' } };
          if (ownerState.align === 'center') return { ...base, textAlign: 'center' };
          return base;
        },
        sizeSmall: { padding: '9px 14px' },
        head: {
          fontSize: '0.75rem',
          fontWeight: 600,
          letterSpacing: '0.01em',
          textTransform: 'none',
          color: theme.vars.palette.grey[600],
          backgroundColor: theme.vars.palette.grey[50],
          borderBottom: `1px solid ${theme.vars.palette.grey[200]}`,
          whiteSpace: 'nowrap'
        },
        footer: { fontSize: '0.75rem', fontWeight: 600 }
      }
    }
  };
}
